import { useState, useContext } from "react";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";
import Select from "../../../../components/basics/Select";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import { ClienteContext } from "../contexts/ClienteContext";
import useClienteController from "../controllers/ClienteController";
import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";
import MaskService from "../../../../utils/mask/maskService";

export default function ModalClienteRelacionado({ open, setOpen }) {
  const { generalCustomerId } = useContext(ClienteContext);
  const [listRelationshipTypes] = useState([
    { type: "Colaborador" },
    { type: "Convênio" },
    { type: "Familiar" },
  ]);
  const [listRelationshipPosition] = useState([
    { position: "Titular" },
    { position: "Dependente" },
  ]);
  const { handleAddRelationship } = useClienteController();
  const [errorsModal, setErrorsModal] = useState({});
  const [relatedClient, setRelatedClient] = useState(null);
  const [relationshipType, setRelationshipType] = useState(
    listRelationshipTypes.find((element) => element.type === "Colaborador")
  );
  const [relationshipPosition, setRelationshipPosition] = useState(
    listRelationshipPosition.find(
      (element) => element.position === "Dependente"
    )
  );

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleAdd = () => {
    const validateRelationship = validNotNull([
      {
        key: "relatedClient",
        value: relatedClient,
      },
      {
        key: "relationshipType",
        value: relationshipType,
      },
      {
        key: "relationshipPosition",
        value: relationshipPosition,
      },
    ]);

    if (
      !validateRelationship.errorsValidation.relatedClient &&
      generalCustomerId &&
      generalCustomerId === relatedClient.id
    ) {
      validateRelationship.error = true;
      validateRelationship.errorsValidation.relatedClient = "Cliente inválido";
      validateRelationship.errorNotify =
        "Cliente relacionado igual ao em cadastro";
    }

    setErrorsModal(validateRelationship.errorsValidation);
    if (validateRelationship.error)
      return notify(
        validateRelationship.errorNotify ??
          "Verifique se os campos estão preenchidos corretamente",
        true,
        "error"
      );

    handleAddRelationship(
      {
        id: relatedClient.id,
        razao: relatedClient.razao,
        pivot: {
          tipo: relationshipType.type,
        },
      },
      relationshipPosition.position
    );

    setOpen(false);
  };

  const relationshipTypeOnChange = (event) => {
    setRelationshipType(event.target.value);
  };

  const relationshipPositionOnChange = (event) => {
    setRelationshipPosition(event.target.value);
  };

  const clientGetOptionLabel = (option) => {
    return `${option.razao} ${
      option.cpfcnpj
        ? `(${MaskService.toMask(
            option.cpfcnpj.replace(/[^0-9]+/g, "").length === 11
              ? "cpf"
              : "cnpj",
            option.cpfcnpj
          )})`
        : ""
    }`;
  };

  return (
    <>
      <Dialog
        open={open}
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Cadastro de Relacionamento
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <SearchSelect
                descriptionField="razao"
                label="Cliente relacionado"
                getOptionLabel={clientGetOptionLabel}
                setValue={setRelatedClient}
                route="prouser/clientes/v1"
                filter="razao"
                error={errorsModal.relatedClient ? true : false}
                helperText={errorsModal.relatedClient || ""}
                value={relatedClient}
              />
            </Grid>
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <Select
                error={errorsModal.relationshipType ? true : false}
                helperText={errorsModal.relationshipType || ""}
                label="Tipo de Relacionamento"
                value={relationshipType}
                onChange={relationshipTypeOnChange}
                optionsList={listRelationshipTypes}
                descriptionField="type"
              />
            </Grid>
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <Select
                error={errorsModal.relationshipPosition ? true : false}
                helperText={errorsModal.relationshipPosition || ""}
                label="Posição"
                value={relationshipPosition}
                onChange={relationshipPositionOnChange}
                optionsList={listRelationshipPosition}
                descriptionField="position"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Incluir" onClick={handleAdd} />
        </DialogActions>
      </Dialog>
    </>
  );
}
